import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "16",
  fill: "none",
  class: "arrow",
  viewBox: "0 0 14 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--_dn-icon_color)",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      d: "m2 2 10 10L2 22"
    }, null, -1)
  ]))]))
}
export default { render: render }